import { Button, Icon, Radio } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext, useEffect } from 'react';
import { Text } from 'components/typography';
import { useGetUserIn2n } from 'services/2n/get-user';
import { useCreateUserIn2n } from 'services/2n/create-user';
import { useUpdateUserIn2n } from 'services/2n/update-user';
import { useModal } from 'store/modals';
import styles from '../../styles.module.scss';
import { UserAdministrationModalContext } from '../../../../../../UserAdministrationModalContext';

export const Manage2nPermissions = () => {
  const intl = useIntl();
  const {
    selectedUser,
    setService,
  } = useContext(UserAdministrationModalContext);
  const getUserIn2N = useGetUserIn2n(selectedUser && selectedUser.email);
  const createUserIn2N = useCreateUserIn2n(selectedUser);
  const updateUserIn2N = useUpdateUserIn2n(getUserIn2N.user);
  const hasAssignedGroups = getUserIn2N.user && getUserIn2N.user.assignedGroups && getUserIn2N.user.assignedGroups.length > 0;

  const isSetupRequiredFor2N = !getUserIn2N.user || !hasAssignedGroups;

  const { openModal, isModalOpen } = useModal();
  const isConfirmationModalOpen = isModalOpen('ConfirmationModal');
  const [hasUserAccessTo2N, setHasUserAccessTo2N] = React.useState(false);

  useEffect(() => {
    if ((selectedUser && getUserIn2N.user && !isConfirmationModalOpen)) {
      setHasUserAccessTo2N(!getUserIn2N?.isSuspended);
    }
  }, [selectedUser, getUserIn2N.user, getUserIn2N?.isSuspended, isConfirmationModalOpen]);

  return (
    <div className={styles.service}>
      <Radio
        label={intl.formatMessage({ id: 'accessControl2n' })}
        toggle
        name="accessControl2n"
        checked={hasUserAccessTo2N}
        disabled={getUserIn2N.isLoading || updateUserIn2N.isLoading}
        onChange={async (event, value) => {
          setHasUserAccessTo2N(value.checked);
          if (!getUserIn2N.user && value.checked) {
            await createUserIn2N.mutateAsync(selectedUser);
          }
          if (getUserIn2N.user && value.checked) {
            updateUserIn2N.mutate({ isSuspended: false });
          }
          if (getUserIn2N.user && !value.checked) {
            openModal({
              modalType: 'ConfirmationModal',
              modalProps: {
                title: intl.formatMessage({ id: 'updatePermissionForUserIn2n' }),
                content: intl.formatMessage({ id: 'updatePermissionForUserIn2nContent' }),
                onConfirm: () => updateUserIn2N.mutate({ isSuspended: true }),
              },
            });
            setHasUserAccessTo2N(value.checked);
          }
        }}
      />

      {hasUserAccessTo2N && (
        <div className={styles.configureService}>

          <Button
            basic
            icon
            labelPosition="right"
            color="primary"
            onClick={() => {
              setService('2N Access Control');
            }}
          >
            <FormattedMessage id="configure" />
            <Icon name="pencil alternate" />
          </Button>

          {isSetupRequiredFor2N && (
          <Text red>
            <FormattedMessage
              id="setupRequired"
            />
          </Text>
          )}

        </div>
      )}

    </div>
  );
};
